/* eslint-disable */
import store from '@/store';

const routePermissions = {
  workdesk_view: '/workers-board',
  rent_view: '/rents',
  rent_rate_view: '/rates',
  book_view: '/bookings',
  car_view: '/autos',
  driver_view: '/drivers',
  investor_view: '/investors',
  company_view: '/settings/companies',
  role_view: '/roles',
  employee_view: '/employees',
  car_park_view: '/parks',
  investor_report_view: '/investor-report',
  fines: '/fines',
  appeals: '/appeals',
  settings_view: '/settings',
  finance_view: '/finance',
  finance_expanse_view: '/finance/company-expenses',
  weekend_schedule_view: '/weekend-schedule',
};

const isException = (to = {}) => {
  const isInvestor = store.getters['global/getRole'] === 'investor';
  return isInvestor && to.name === 'auto-info';
};

const checkRouteAccess = (permission, next, to) => {
  store.commit('global/setRole', null, { root: true });

  if (isException(to)) {
    return next();
  }

/*  if (store.getters['global/getRole'] === 'investor') {
    next('/investor-board');
  }*/

  // if (store.getters['global/getRole'] === 'mechanic') {
  //   next('/mechanic/rents');
  // }

  const user = JSON.parse(localStorage.getItem('me'));
  const { permissions } = user.role_permissions;
  const can = permissions.some(({ name }) => name === permission);

  if (can) {
    return next();
  }

  for (let item of permissions) {
    const path = routePermissions[item.name];

    if (path) {
      next(path);
      break;
    }
  }
};

export default checkRouteAccess;
